import { AppSelectBaseFilter } from '@/presentation/components';
import React from 'react';
const AppSelectFilter = ({ name, label, placeholder, required, options, state, setState, onChange }) => {
    return (React.createElement(AppSelectBaseFilter, { state: state, options: options, setState: setState, name: name, label: label, placeholder: placeholder, required: required, onChange: onChange, width: "150px" }));
};
export default AppSelectFilter;
